import { deleteCookie, inIframe, useEffectOnce, usePathParam } from '@chilecompra/react-kit'
import { LinkButton, Typography } from '@chilecompra/react-kit/components'
import React from 'react'

import { useSelector } from 'react-redux'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import ProtectByProfile from '../components/Security/ProtectByProfile'
import { REACT_APP_BASE_URL, REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../config/settings/environment'
import { PATH_PARAM } from '../config/settings/regexes'
import routes from '../config/settings/routes'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import AuthorizationContext from '../containers/AuthorizationProvider/AuthorizationProvider.context'
import HeaderContainer from '../containers/Header/Header.container'
import HeadingSectionContainer from '../containers/HeadingSection/HeadingSection.container'
import HistoricalSanctionsListContainer from '../containers/HistoricalSanctionsList/HistoricalSanctionsList.container'
import NotFoundPage from '../pages/NotFound'
import { Content, Root, Strong } from './HistoricalSanctionsList.styles'

const MENU_LINK = `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`

/**
 * The HistoricalSanctionsList page.
 */
const HistoricalSanctionsList = () => {
  const dni = usePathParam('rut')

  const { loading, searching } = useSelector(state => state.historicalSanctionsList)
  const contractualBehaviorLink = routes.contractualBehavior.replace(PATH_PARAM, dni)

  const handleClickHome = event => {
    event.preventDefault()
    deleteCookie('access_token')
    window.open(MENU_LINK, '_top')
  }

  const breadcrumbs = userType =>
    [
      { text: 'Escritorio', link: MENU_LINK, isExternal: true, onClick: handleClickHome },
      userType !== 'Proveedor' && {
        text: 'Búsqueda Proveedor',
        link: `${REACT_APP_BASE_URL}/busqueda`,
        isExternal: true
      },
      { text: dni, link: contractualBehaviorLink, isExternal: false },
      { text: 'Sanciones históricas' }
    ].filter(Boolean)

  useEffectOnce(() => {
    if (inIframe()) {
      window.parent.postMessage({ action: 'scrollTo', value: { x: 0, y: 0 } }, REACT_APP_MERCADO_PUBLICO_BASE_URL)
    } else window.scrollTo(0, 0)
  })

  const renderContent = userType => (
    <Content>
      <BrandLayout
        featured={
          <HeadingSectionContainer
            breadcrumbs={breadcrumbs(userType)}
            subtitle={
              <Typography variant="body2">
                Estas son las sanciones del proveedor que han superado los 24 meses desde la fecha de aceptación de la
                orden de compra. Estas sanciones <Strong>no son consideradas en la nota de comportamiendo base</Strong>{' '}
                del proveedor.
              </Typography>
            }
            title={
              <Typography fontWeight="bold" margin="32px 0 0" variant="h2">
                Historial de sanciones
              </Typography>
            }
          />
        }
        header={<HeaderContainer />}
      >
        <Root>
          <HistoricalSanctionsListContainer />

          <LinkButton
            color="default"
            disabled={loading || searching}
            to={contractualBehaviorLink}
            variant="outlined"
            width="100px"
          >
            Volver
          </LinkButton>
        </Root>
      </BrandLayout>
    </Content>
  )

  return (
    <ProtectByFeatures fallback={() => <NotFoundPage />} rule={features => features['com.seller/contractual.behavior']}>
      <AuthorizationProviderContainer>
        <AuthorizationContext.Consumer>
          {({ userType }) => (
            <ProtectByProfile
              fallback={() => <NotFoundPage />}
              rule={userType => userType === 'Comprador' || userType === 'Proveedor'}
            >
              {renderContent(userType)}
            </ProtectByProfile>
          )}
        </AuthorizationContext.Consumer>
      </AuthorizationProviderContainer>
    </ProtectByFeatures>
  )
}
export default HistoricalSanctionsList
